<script lang="ts">
	//Design system components
	import { Alert, Button, Container, Radio, Text } from '@Shelly/shelly-design-system';
	//Configs
	import { devices_config } from '@devices/index';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import {
		get_gen_2_component_channel_structure,
		get_mode,
		real_id,
	} from 'src/helpers/interface_helpers';
	import { capFirstChar, genCharArray } from 'src/helpers/utilities';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
		import { getDeviceStatus, getDeviceSettings, readDeviceStatus } from 'src/stores/device-runtime/status-selectors';

	$: statusStore = getDeviceStatus(device.id);
	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let loading = false;
	const mode = get_mode(
		device,
		$settingsStore,
		$statusStore,
	);

	const phasesNUmber = devices_config[device.type]?.modes?.[mode]?.phases;
	const phases = genCharArray(phasesNUmber);
	const userCalibratedPhases =
		$statusStore?.[get_gen_2_component_channel_structure(device)]
			?.user_calibrated_phase;
	const hasDifference = userCalibratedPhases?.length > 0;

	const resetPhasesTitle = hasDifference
		? $format('phases_differece_description', {
				default: 'Phases below differs from factory calibration.',
			})
		: $format('phases_no_difference_description', {
				default: 'All phases are with their factory calibrations.',
			});

	let phaseForReset = userCalibratedPhases?.[0];

	const selectPhaseFrom = (phase) => {
		phaseForReset = phase;
	};

	const setCalibration = async () => {
		loading = true;
		const res = await gen2Request(device, 'EM.PhaseToPhaseCalibReset', {
			id: 0,
			phase: phaseForReset,
		});
		await onSettingsResponse(res, device);
		loading = false;
	};
</script>

{#if hasDifference}
	<Container class="mb-s">
		<Text class="mb-m" styleType="body-small">{resetPhasesTitle}</Text>
		{#each userCalibratedPhases as phase, index}
			<Radio
				class="mb-s"
				size="m"
				disabled={loading}
				selected={phaseForReset}
				value={phases[index]}
				on:click={() => selectPhaseFrom(phase)}
				id="radio-1qvlq26"
				>{$format(`label_phase_${phase}`, { default: `Phase ${phase}` })}</Radio
			>
		{/each}
	</Container>
{:else}
	<Alert class="mb-s" type="info" heading={$format('label_info')} message={resetPhasesTitle} />
{/if}

<Button {loading} disabled={!hasDifference} width="full" size="m" on:click={setCalibration}
	>{capFirstChar($format('button_reset'))}</Button
>
